const PREFIX = 'popup-hide-until:';

const getStorageKey = (popupId: number) => {
  return `${PREFIX}${popupId}`;
};

const getHideUntil = (popupId: number): number | null => {
  if (typeof window === 'undefined') return null;

  const raw = window.localStorage.getItem(getStorageKey(popupId));
  if (!raw) return null;

  const parsed = Number(raw);

  if (Number.isNaN(parsed)) {
    window.localStorage.removeItem(getStorageKey(popupId));
    return null;
  }

  return parsed;
};

export const shouldShowPopup = (popupId: number): boolean => {
  if (typeof window === 'undefined') return false;

  const hideUntil = getHideUntil(popupId);
  if (!hideUntil) return true;

  return Date.now() > hideUntil;
};

export const hidePopupUntilEndOfDay = (popupId: number) => {
  if (typeof window === 'undefined') return;

  const now = new Date();
  const endOfDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59,
    999,
  ).getTime();

  window.localStorage.setItem(getStorageKey(popupId), String(endOfDay));
};

export const hidePopupForDays = (popupId: number, days: number) => {
  if (typeof window === 'undefined') return;

  const now = new Date();
  const endOfDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() + days,
    23,
    59,
    59,
    999,
  ).getTime();

  window.localStorage.setItem(getStorageKey(popupId), String(endOfDay));
};
